<div class="wrap">

    <h1>Camera information</h1>

    <div class="dashboard_content">
        <div class="maps_camera_select">
            <div class="maps">
                <agm-map [zoom]="zoom" [latitude]='lat' [longitude]='lng' fullscreenControl='true' [fitBounds]="true">
                    <agm-marker-cluster
                        imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">

                        <ng-container *ngFor="let d of getCameraFiltered()">
                            <agm-marker [agmFitBounds]="true" [latitude]="d.location.lat" [longitude]="d.location.lng">
                            </agm-marker>
                        </ng-container>

                    </agm-marker-cluster>
                </agm-map>
            </div>
            <mat-spinner [diameter]="50" *ngIf="loading"></mat-spinner>

        </div>

        <div class='table_content'>

            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" *ngIf="!isAdmin">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'"> Name </th>
                    <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
                        {{element?.name}}({{element.externalId}}) </td>
                </ng-container>

                <ng-container matColumnDef="localisation">
                    <th mat-header-cell *matHeaderCellDef class="cell_action" [style.text-align]="'center'">
                        Location </th>
                    <td mat-cell *matCellDef="let element" class="cell_action" [style.text-align]="'center'">
                        {{element.Localisation}}

                        <fa-icon [icon]="faMarker" (click)="updateMarker(element)"
                            matTooltip="show location">
                        </fa-icon>

                    </td>
                </ng-container>

                <ng-container matColumnDef="battery">
                    <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
                        Battery </th>
                    <td mat-cell *matCellDef="let element" [style.text-align]="'center'"> {{element.battery}}% </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            </table>
            <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                aria-label="Select page">
            </mat-paginator>

        </div>

    </div>
</div>
